<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
*{
  margin: 0;
  font-size: 16px
}

</style>
